import { type DocumentNode, gql } from '@apollo/client';

const showMyCollections: DocumentNode = gql`
  query myColl {
    allCollections(ownedByUser: true, collectionType: PLAYLIST) {
      edges {
        node {
          id
          name
          collectionType
          items {
            edges {
              node {
                contentObject {
                  ... on AssetNodeType {
                    id
                    mediatype
                    formatSet {
                      edges {
                        node {
                          id
                          fmtType {
                            id
                            name
                            slug
                            suffix
                            downloadable
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default showMyCollections;
